const ones = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];
const tens = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];

function twoDigits(n: number): string {
  return n < 20
    ? ones[n]
    : tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
}

function threeDigits(n: number): string {
  const h = Math.floor(n / 100);
  const r = n % 100;
  return (
    (h ? ones[h] + " Hundred" + (r ? " " : "") : "") + (r ? twoDigits(r) : "")
  );
}

export function numberToWordsIndian(num: number): string {
  if (num === 0) {
    return "Zero";
  }
  let n = num;
  const crore = Math.floor(n / 10000000);
  n %= 10000000;
  const lakh = Math.floor(n / 100000);
  n %= 100000;
  const thousand = Math.floor(n / 1000);
  n %= 1000;
  const hundred = n;
  let s = "";
  if (crore) {
    s += threeDigits(crore) + " Crore ";
  }
  if (lakh) {
    s += twoDigits(lakh) + " Lakh ";
  }
  if (thousand) {
    s += twoDigits(thousand) + " Thousand ";
  }
  if (hundred) {
    s += threeDigits(hundred);
  }
  return s.trim() + " Rupees Only";
}
